// Time zone choices for v2 dropdowns (My profile, Client settings › Company): every IANA zone the browser knows,
// labelled "Australia/Perth (AWST)" with the abbreviation as the browser names it today.
export const BROWSER_TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

const TIME_ZONES: string[] = (Intl as any).supportedValuesOf?.('timeZone') ?? [BROWSER_TIME_ZONE];

const zoneLabel = (tz: string) => {
    const abbr = new Intl.DateTimeFormat('en-AU', { timeZone: tz, timeZoneName: 'short' }).formatToParts(new Date()).find(x => x.type === 'timeZoneName')?.value;
    return abbr ? `${tz} (${abbr})` : tz;
};

export const TIME_ZONE_OPTIONS = TIME_ZONES.map(tz => ({ value: tz, label: zoneLabel(tz) }));
